<template>
  <div class="driver-buttons">
    <div class="wrapper has-text-right">
      <!-- <span class="tag is-rounded more" @click="roleInfo">
        <span class="fa fa-ellipsis-v fa-lg" style="margin: 1px" />
      </span> -->
      <span class="busy tag is-white is-rounded" @click="toggleHideNewJobs">
        <i v-if="hideNewJobs" class="fa fa-eye-slash fa-lg has-text-danger" />
        <i v-else class="fa fa-eye fa-lg" :class="blockNewJobs ? 'has-text-grey' : 'has-text-success'" />
      </span>
      <span class="busy tag is-white is-rounded" :class="busyClass" @click="togglePause">
        <i v-if="isBusy" class="fa fa-volume-mute fa-lg" />
        <i v-else class="fa fa-bullhorn fa-lg" />
      </span>
      <toggle-button style="margin-top: -2px" :value="switchState" :color="{ checked: '#00D1B2', unchecked: '#FF3860' }"
        :sync="true" :labels="{ checked: $t('on'), unchecked: $t('off') }" :height="25" :width="55"
        @change="startStopWork($event.value)" />
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";

export default {
  name: "DriverButtons",
  components: {},
  props: {},
  data() {
    return {
      switchState: false,
    };
  },
  computed: {
    hideNewJobs() {
      return this.$store.state.driverSettingHideNewJobs;
    },
    blockNewJobs() {
      return this.$store.getters.driverHasActiveJobsNotEnroute;
    },
    role() {
      return this.$store.getters.getDriverRole;
    },
    isBusy() {
      if (!this.role) return false;
      return this.role.data.is_busy;
    },
    isWorking() {
      return this.$store.state.isWorking;
    },
    bizName() {
      return this.role.business.name;
    },
    busyClass() {
      if (this.isBusy || !this.isWorking) return "is-danger";
      return "is-primary";
    },
  },
  activated() {
    this.initialise();
    if (this.$route.query.start_work == "true") this.startWork();
  },
  mounted() {
    this.checkRoleData();
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setRoles") this.initialise();
    });
    EventBus.$on("UPDATED_DRIVER_ROLE", () => this.startWork());
    EventBus.$on("DRIVER_START_WORKING", () => this.startWork());
    EventBus.$on("DRIVER_REALLY_START_WORKING", () => {
      if (!this.isWorking) this.setWorking(true); // called when driver accepts a job
    });
  },
  methods: {
    initialise() {
      this.switchState = this.isWorking;
      if (this.isWorking) this.pollLocation();
    },
    toggleHideNewJobs() {
      // this.showNewJobs = !this.showNewJobs;
      this.$store.commit("toggleDriverSettingHideNewJobs");
      if (this.hideNewJobs) {
        // this.warningToast("Hide new jobs when busy", "top");
        this.warningToast("ซ่อนงานใหม่เมื่อไม่ว่าง", "top");
      } else {
        // this.infoToast("Show new jobs all the time", "top");
        this.infoToast("แสดงงานใหม่ตลอดเวลา", "top");
      }
      EventBus.$emit("SHOW_DRIVER_IGNORED_JOBS");
    },
    togglePause() {
      if (this.isBusy) {
        var msg = this.$t("driver.notifications-on");
        this.sendPushNotification(msg, this.userID());
        if (this.isSoundOn()) sounds("navigate2");
      }
      // default values if notifications are ON
      var onOff = this.$t("on");
      var txt = this.$t("driver.notifications-on");
      var color = this.bulmaColor("success");
      var icon = `<i class='fa fa-bullhorn fa-2x' style='color:${color}'></i>`;
      if (!this.isBusy) {
        onOff = this.$t("off");
        txt = this.$t("driver.notifications-off");
        color = this.bulmaColor("danger");
        icon = `<i class='fa fa-volume-mute fa-2x' style='color:${color}'></i>`;
      }
      this.$swal({
        title: `${this.$t("driver.notifications")}: ${onOff}`,
        html: `${icon}<br><br>${txt}`,
        showConfirmButton: false,
        showCloseButton: true,
      });
      this.dispatchRoleBusyPatch();
    },
    checkRoleData() {
      //   console.warn("check role.data", this.role.data);
      var plate = this.role.data.vehicle_number;
      // you can set vehicle_number to "1" for testing
      if (!plate || plate === "" || plate === "1") {
        this.$swal({
          title: this.$t("driver.please-enter-role-details"),
          html: "<div style='font-size:2em'>🙏🏽</div>",
          confirmButtonText: this.$t("okay"),
        }).finally(() => EventBus.$emit("EDIT_ROLE_MODAL", this.role));
        return true; // need to check role data
      }
      return false; // role data looks okay, so no need to check
    },
    startStopWork(val) {
      this.switchState = val;
      if (val) this.startWork();
      else this.stopWork();
    },
    startWork() {
      console.log("startWork", this.checkRoleData(), this.isWorking);
      if (this.checkRoleData()) return; // set required role data
      if (this.isWorking) return; // already working
      var r = this.role;
      // var roleName = this.$t("driver.driver");
      var green = this.bulmaColor("primary");
      this.$swal({
        // title: `<i class="fa fa-thumbs-up fa-2x" style="color:${green}"/>`,
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-thumbs-up fa-lg'></i>&nbsp; 
          ${this.$t("driver.ready-to-start-working")}
        </p>
        <p>${r.business.name} - ${r.workflow_name}</p>
        </div>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        confirmButtonColor: green,
      }).then((val) => {
        if (val.value) this.setWorking(true);
        else this.switchState = false;
      });
    },
    stopWork() {
      if (this.$store.getters.driverHasOngoingPassengers) {
        // if driver has ongoing passenger transactions don't let them stop working
        this.$nextTick(() => (this.switchState = true)); // nextTick magic
        var text = this.$t("driver.complete-before-stop-work");
        return this.warningAlert(text);
      }
      var blue = this.bulmaColor("info");
      this.$swal({
        title: this.$t("driver.done-working"),
        html: `<i class="fa fa-moon fa-4x" style="color: ${blue}" />`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        confirmButtonColor: blue,
      }).then((val) => {
        if (val.value) this.setWorking(false);
        else this.switchState = true;
      });
    },
    setWorking(stateTrue) {
      if (stateTrue) {
        if (this.isSoundOn()) sounds("money");
        this.switchState = true;
        this.$store.commit("setWorkingState", this.role);
        this.$store.commit("setMapState");
        this.dispatchRoleStatePatch("working");
      } else {
        if (this.isSoundOn()) sounds("parrot");
        this.$store.commit("setWorkingState", null);
        this.$store.commit("setMapState");
        this.dispatchRoleStatePatch("not-working");
      }
    },
    dispatchRoleStatePatch(state) {
      this.role.state = state;
      if (state === "working") {
        this.role.data.is_busy = false; // if starting to work also set is_busy = false
        var data = this.role.data; // send all the data back, not just is_busy
      }
      var payload = { id: this.role.id, state: state, data: data };
      var loader = this.loadingDots("seagreen");
      this.$store
        .dispatch("setRoleState", payload)
        .then((res) => {
          this.console("setRoleState", res);
          if (state === "working") {
            var msg = `${this.$t("driver.notifications")} ${this.$t("on")}`;
            this.sendPushNotification("👍🏼 " + msg, this.userID());
          }
        })
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.updateTransactionsForDriver(true);
        });
    },
    // toggle is_busy t/f
    dispatchRoleBusyPatch() {
      this.role.data.is_busy = !this.role.data.is_busy;
      var data = this.role.data; // send all the data back, not just is_busy
      var payload = { id: this.role.id, data: data };
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => this.console("updateRoleData", res))
        .catch((err) => this.apiError(err));
    },
    // roleInfo() {
    //   var r = this.role;
    //   var suffix = "";
    //   if (this.isSuperUser()) {
    //     var iconName = r.workflow.data.icon || r.workflow.name;
    //     suffix = `<p style="font-size:0.6em; font-weight:550; background-color:lightgreen; padding:3px; border-radius:3px">Icon ${iconName}</p>`;
    //   }
    //   var html = `<div style='text-align:left; font-size:1.25em; margin-top:10px'>
    //     <p style='font-size:1.15em; font-weight:550; opacity:0.7'>${r.business.name}</p>
    //     <p>${r.workflow_name} - ${r.role_name}</p>
    //     ${suffix}</div>`;
    //   this.$swal({
    //     // title: "<i class='fa fa-info-circle fa-lg' style='color:#007BA7'></i>",
    //     html: html,
    //     showConfirmButton: true,
    //     showCloseButton: true,
    //     showCancelButton: true,
    //     confirmButtonText: this.$t("edit"),
    //     cancelButtonText: this.$t("close"),
    //     confirmButtonColor: "orange",
    //     // cancelButtonColor: "#007BA7",
    //   }).then((val) => {
    //     if (val.value) {
    //       EventBus.$emit("EDIT_ROLE_MODAL", this.role);
    //     }
    //   });
    // },
  },
};
</script>

<style scoped>
.driver-buttons {
  position: absolute;
  top: 0;
  z-index: 1;
}

.wrapper {
  z-index: 2;
  width: 100vw;
  padding: 12px 60px;
  filter: drop-shadow(2px 2px 2px #666);
}

.busy {
  margin-right: 12px;
}

.more {
  margin-right: 12px;
}

.biz-info {
  position: absolute;
  left: 60px;
  overflow: hidden;
  font-weight: 500;
}
</style>